import React, {Component} from 'react';
import { injectStripe, CardElement } from 'react-stripe-elements';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import MixpanelButton from "../components/MixpanelButton";
import MixpanelTextField from "../components/MixpanelTextField";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

import StripeInput from '../components/StripeInput';

import GA from '../utils/GoogleAnalytics';
import cvcTip from '../img/cvcTip.jpeg';
import allCardsImage from '../img/cards/3_Card_color_horizontal.svg';

class CheckoutForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            processingPayment: false,
            email: '',
            planId: this.props.planId,
            skipPayment: false,
            show3DSecureDialog: false,
            clientSecret: null,
            error: null
        };
        this.submit = this.submit.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handle3DSecureComplete = this.handle3DSecureComplete.bind(this);
    }
    componentDidUpdate(prevProps) {
        const keyList = ['email'];
        const updates = {};
        let ct = 0;
        //console.log(['didUpdate', prevProps, this.props]);
        for (let i in keyList) {
            const k = keyList[i];
            if (prevProps[k] != this.props[k]) {
                updates[k] = this.props[k];
                ct++;
            }
        }
        if (ct > 0){
            //console.log(updates);
            this.setState(updates);
        }
    }
    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    handle3DSecureComplete = async (result) => {
        if (result.error) {
            this.setState({ error: result.error.message });
            this.setState({ show3DSecureDialog: false });
            return;
        }

        // 3Dセキュア認証が成功したら、支払い方法を保存
        const formData = {
            'email': this.state.email
        };
        const postData = JSON.stringify({
            'planId': this.state.planId,
            'skipPayment': this.state.skipPayment,
            'paymentMethodId': result.paymentMethod.id,
            'formData': formData
        });

        try {
            const response = await fetch("/api/plan/setPayment", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: postData
            });

            if (response.ok) {
                this.props.setCompletePayment();
            } else {
                this.setState({ error: '支払い方法の保存に失敗しました' });
            }
        } catch (err) {
            this.setState({ error: 'エラーが発生しました' });
        } finally {
            this.setState({ show3DSecureDialog: false });
            this.setState({ processingPayment: false });
        }
    }

    async submit(ev, mixpanel) {
        const {hasPaymentMethod, planId } = this.props;
        const {skipPayment} = this.state;
        this.setState({processingPayment: true})
        let msg = "Are you sure want to register credit card for payment?";
        let gaActions = "Register credit card detail";
        if ( skipPayment ) {
            msg = "Please setup payment later from dashboard.";
            gaActions = "Finish without payment";
        }
        else if (hasPaymentMethod) {
            msg = "Are you sure want to change your credit card?";
            gaActions = "Change credit card detail";
        }
        if (mixpanel) {
            mixpanel.track('kiara_app_com_try_pay');
        }
        const confirm = window.confirm(msg);
        if (confirm) {
            try {
                if (skipPayment) {
                    GA.Event('Dashboard', gaActions, 'Payment');
                    this.props.setCompletePayment();
                    return;
                }

                if (!this.props.elements || !this.props.stripe) {
                    throw new Error('Stripe is not initialized');
                }

                const cardElement = this.props.elements.getElement('card');

                if (!cardElement) {
                    throw new Error('Card element not found');
                }

                GA.Event('Dashboard', gaActions, 'Payment');
                let paymentMethod = null;
                console.log("Creating payment method...");
                const { paymentMethod: pm, error } = await this.props.stripe.createPaymentMethod({
                    type: 'card',
                    card: cardElement,
                    billing_details: {
                        name: "Kiara-Payment",
                        email: this.state.email
                    }
                });

                if (error) {
                    console.error("Payment method creation error:", error);
                    this.setState({ error: error.message });
                    return;
                }

                paymentMethod = pm;
                console.log("Payment method created:", paymentMethod);

                console.log("Creating setup intent...");
                const response = await fetch("/api/plan/createSetupIntent", {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        paymentMethodId: paymentMethod.id
                    })
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Setup Intentの作成に失敗しました');
                }

                const { clientSecret } = await response.json();

                const { setupIntent, error: confirmError } = await this.props.stripe.confirmCardSetup(
                    clientSecret,
                    {
                        payment_method: paymentMethod.id
                    }
                );

                if (confirmError) {
                    console.error("Card setup confirmation error:", confirmError);
                    this.setState({ error: confirmError.message });
                    return;
                }

                if (setupIntent.status === 'requires_action') {
                    console.log("3D Secure authentication required");
                    this.setState({
                        show3DSecureDialog: true,
                        clientSecret: clientSecret
                    });
                    return;
                }

                const formData = {
                    'email': this.state.email
                };
                const postData = JSON.stringify({
                    'planId': planId,
                    'skipPayment': skipPayment,
                    'paymentMethodId': paymentMethod.id,
                    'formData': formData
                });

                const setPaymentResponse = await fetch("/api/plan/setPayment", {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    mode: "no-cors",
                    body: postData
                });

                if (!setPaymentResponse.ok) {
                    const errorData = await setPaymentResponse.json();
                    throw new Error(errorData.message || '支払い方法の保存に失敗しました');
                }

                this.props.setCompletePayment();
            } catch (err) {
                console.error("Error in submit:", err);
                this.setState({ error: err.message || 'エラーが発生しました' });
            } finally {
                this.setState({processingPayment: false});
            }
        } else {
            this.setState({processingPayment: false});
        }
    }

    toggleSkipPayment () {
        if (this.state.skipPayment) {
            this.setState({skipPayment: false})
        }
        else {
            this.setState({skipPayment: true})
        }
    }

    cvcInfo () {
        return <Typography>
            3-digit security code usually found on the back of your card.
            <img src={cvcTip} alt="cvc-tip" style={ { display: "block" }}/>
        </Typography>
    }

    getMainForm () {
        const { isTrial } = this.props;
        const { skipPayment } = this.state;
        if (isTrial && skipPayment) {
            return null;
        }
        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <img src={allCardsImage} alt="American Express VISA Master Card" width="360"/>
                </Grid>
                <Grid item xs={12}>
                    <div className="user-form-email">
                        <MixpanelTextField
                            mixpanelMessage="kiara_app_com_select_plan_put_email"
                            label="Email"
                            type="email"
                            value={this.state.email}
                            onChange={this.handleEmailChange}
                            id="email"
                            name="email"
                            placeholder="Your email"
                            variant="standard"
                            required
                            fullWidth
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <MixpanelTextField
                        mixpanelMessage="kiara_app_com_select_plan_put_card_number"
                        label="Credit Card"
                        name="card"
                        variant="standard"
                        required
                        fullWidth
                        InputProps={{
                            inputComponent: StripeInput,
                            inputProps: {
                                component: CardElement,
                            },
                        }}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
            </React.Fragment>
        );
    }

    render() {
        const { hasPaymentMethod, isTrial, canSkip } = this.props;
        const { skipPayment, error, show3DSecureDialog } = this.state;

        let skipText = null;
        if (isTrial && canSkip) {
            skipText = <div className="user-form">
                <input type="checkbox" value={true} onClick={this.toggleSkipPayment.bind(this)} />Skip now<br />
            </div>;
        }

        let submitMessage = 'Update Plan and Payment';
        let mixpanelMessage = 'kiara_app_com_select_plan_update_and_payment_button';
        if (!skipPayment) {
            if (hasPaymentMethod) {
                submitMessage = 'Update Payment';
                mixpanelMessage = 'kiara_app_com_select_plan_update_payment_button';
            } else {
                submitMessage = 'Register Payment';
                mixpanelMessage = 'kiara_app_com_select_plan_register_plan_button';
            }
        } else {
            submitMessage = 'Confirm';
        }

        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {skipText}
                </Grid>

                {this.getMainForm()}

                <Grid item xs={12}>
                    <MixpanelButton 
                        mixpanelMessage={mixpanelMessage} 
                        color="primary" 
                        variant="contained" 
                        disabled={this.state.processingPayment} 
                        onClick={this.submit} 
                        sx={{ width: '100%'}}
                    >
                        {submitMessage}
                    </MixpanelButton>
                </Grid>

                {error && (
                    <Grid item xs={12}>
                        <Typography color="error">
                            {error}
                        </Typography>
                    </Grid>
                )}

                <Dialog 
                    open={show3DSecureDialog} 
                    maxWidth="sm" 
                    fullWidth
                >
                    <DialogTitle>3D Secure Authorize</DialogTitle>
                    <DialogContent>
                        <Typography>
                            Please authorize your card.
                        </Typography>
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <CircularProgress />
                        </div>
                    </DialogContent>
                </Dialog>
            </Grid>
        );
    }
}

CheckoutForm.defaultProps = {
}

export default injectStripe(CheckoutForm);
